import { defineMessages } from 'react-intl';

export default defineMessages({
  dateRanges: 'Date ranges',
  selectDateRanges: 'Date range',
  today: 'Today',
  yesterday: 'Yesterday',
  lastWeek: 'Last week',
  lastMonth: 'Last month',
  lastQuarter: 'Last quarter',
  lastYear: 'Last year',
  presets: 'Presets',
  customRange: 'Configure',
  compareToPrevious: 'Compare with',

  last: 'Last',
  this: 'This',
  fixed: 'Custom dates',
  fixedWeeks: 'Custom weeks',
  fixedMonths: 'Custom months',

  previous: 'previous periods',
  previousYears: 'previous years',
  compareFixed: 'custom dates',
  years: 'years',
  quarters: 'quarters',
  months: 'months',
  weeks: 'weeks',
  days: 'days',

  year: 'year',
  quarter: 'quarter',
  month: 'month',
  week: 'week',
  day: 'day',

  apply: 'Apply',
  reset: 'Reset',
  cancel: 'Cancel',

  placeholder: 'Choose a date range',
});
